import { ca } from '@cian/analytics';

import { EPageKind } from '../../../types/page';
import { getEventCategoryFromPageKind } from '../../../utils/tracking';

interface IOptions {
  pageKind: EPageKind;
  buttonType: 'prev' | 'next';
}

const ACTIONS = {
  prev: 'property_guides_click_left',
  next: 'property_guides_click_right',
};

export function trackSliderClick({ pageKind, buttonType }: IOptions) {
  ca('eventSite', {
    category: getEventCategoryFromPageKind(pageKind),
    action: ACTIONS[buttonType],
  });
}
